
import { defineComponent, watch } from "vue";
import usePrices from "@/composables/usePrices";

export default defineComponent({
    name: "TotalPrice",
    setup() {
        const { totalPriceFormatted, priceElement } = usePrices();

        watch(totalPriceFormatted, () => {
            priceElement &&
                (priceElement.innerHTML = totalPriceFormatted.value);
        });
    }
});
